__turbopack_context__.v({
  "container": "LogoSection-module__8p-J4q__container",
  "dieselLogo": "LogoSection-module__8p-J4q__dieselLogo",
  "divider": "LogoSection-module__8p-J4q__divider",
  "logoWrapper": "LogoSection-module__8p-J4q__logoWrapper",
  "section": "LogoSection-module__8p-J4q__section",
  "uhLogo": "LogoSection-module__8p-J4q__uhLogo",
});
